// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BottomActionSheet Overrides */
[data-rsbs-header] {
  box-shadow: none;
  padding-top: calc(24px + env(safe-area-inset-top));
}

[data-rsbs-header]::before {
  width: 28px;
  height: 3px;
  background-color: #585858;
  top: calc(18px + env(safe-area-inset-top));
}

[data-rsbs-has-header='false'] [data-rsbs-header] {
  padding-top: calc(32px + env(safe-area-inset-top));
}
`, "",{"version":3,"sources":["webpack://./styles/BottomActionSheet.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":["/* BottomActionSheet Overrides */\n[data-rsbs-header] {\n  box-shadow: none;\n  padding-top: calc(24px + env(safe-area-inset-top));\n}\n\n[data-rsbs-header]::before {\n  width: 28px;\n  height: 3px;\n  background-color: #585858;\n  top: calc(18px + env(safe-area-inset-top));\n}\n\n[data-rsbs-has-header='false'] [data-rsbs-header] {\n  padding-top: calc(32px + env(safe-area-inset-top));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
